export const colors = [
  'rgb(255, 99, 132)',
  'rgb(75, 192, 192)',
  'rgb(255, 205, 86)',
  'rgb(174,131,196)',
  'rgb(54, 162, 235)',
  'rgb(190,235,54)',
];
